export const INITIALIZE_FOLDERS = 'INITIALIZE_FOLDERS';
export const SET_FOLDER_TREE = 'SET_FOLDER_TREE';
export const SET_CURRENT_PATH = 'SET_CURRENT_PATH';
export const SET_SNACKBAR = 'SET_SNACKBAR';